import { Link } from 'react-router-dom';

export default function AboutTrust() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          {/* Left: Text */}
          <div className="lg:w-2/5">
            <span className="inline-block px-3 py-1.5 rounded-full border border-background-200 text-foreground-500 text-xs font-label tracking-wide mb-6">
              Chi scrive le guide Itaobuy
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-3">
              ITAOBUY
              <br />
              <span className="font-light text-foreground-400">SPREADSHEET</span>
            </h2>
            <p className="text-foreground-500 italic text-sm mb-6 font-heading">Italian Research Hub</p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              Siamo un team indipendente di ricercatori italiani dedicato ad analizzare, catalogare e recensire i migliori prodotti disponibili tramite Itaobuy Spreadsheet. Il nostro obiettivo è fornire una risorsa completa, trasparente e sempre aggiornata per chi cerca prodotti di qualità nel mondo dello shopping online.
            </p>

            {/* Navigation Links with Images */}
            <div className="space-y-3 mb-6">
              <Link
                to="/cos-e-itaobuy-spreadsheet"
                className="flex items-center gap-3 p-3 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer group"
              >
                <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Open%20book%20on%20cream%20desk%20with%20soft%20natural%20lighting%2C%20editorial%20knowledge%20concept%2C%20warm%20minimal%20aesthetic%2C%20clean%20composition%2C%20no%20text%20no%20people%2C%20educational%20photography%20style%2C%20serene%20atmosphere&width=120&height=120&seq=about-link-guida-20&orientation=squarish"
                    alt="Guida Itaobuy"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-label font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors">Cos'è Itaobuy Spreadsheet</p>
                  <p className="text-xs text-foreground-500 mt-0.5">Guida completa per principianti</p>
                </div>
                <i className="ri-arrow-right-line text-foreground-400 group-hover:text-accent-500 transition-colors"></i>
              </Link>

              <Link
                to="/come-funziona-itaobuy"
                className="flex items-center gap-3 p-3 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer group"
              >
                <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Step%20by%20step%20tutorial%20concept%20on%20tablet%20with%20minimal%20cream%20workspace%2C%20soft%20natural%20lighting%2C%20educational%20photography%20style%2C%20warm%20aesthetic%2C%20clean%20composition%2C%20no%20text%20no%20people%2C%20modern%20learning%20atmosphere&width=120&height=120&seq=about-link-tutorial-21&orientation=squarish"
                    alt="Tutorial Itaobuy"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-label font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors">Come Funziona Itaobuy</p>
                  <p className="text-xs text-foreground-500 mt-0.5">Tutorial passo dopo passo</p>
                </div>
                <i className="ri-arrow-right-line text-foreground-400 group-hover:text-accent-500 transition-colors"></i>
              </Link>

              <Link
                to="/itaobuy-sicuro"
                className="flex items-center gap-3 p-3 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer group"
              >
                <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Security%20shield%20concept%20on%20minimal%20cream%20workspace%2C%20soft%20natural%20lighting%2C%20trust%20and%20verification%20theme%2C%20warm%20aesthetic%2C%20clean%20composition%2C%20no%20text%20no%20people%2C%20safety%20photography%20style&width=120&height=120&seq=about-link-sicuro-22&orientation=squarish"
                    alt="Sicurezza Itaobuy"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-label font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors">Itaobuy è Sicuro?</p>
                  <p className="text-xs text-foreground-500 mt-0.5">15 controlli di sicurezza</p>
                </div>
                <i className="ri-arrow-right-line text-foreground-400 group-hover:text-accent-500 transition-colors"></i>
              </Link>

              <Link
                to="/migliori-prodotti-itaobuy"
                className="flex items-center gap-3 p-3 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer group"
              >
                <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Top%20rated%20products%20flat%20lay%20with%20star%20ratings%20on%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20product%20showcase%2C%20warm%20aesthetic%2C%20clean%20composition%2C%20no%20text%20no%20people%2C%20premium%20selection%20concept&width=120&height=120&seq=about-link-migliori-23&orientation=squarish"
                    alt="Migliori Prodotti Itaobuy"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-label font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors">Migliori Prodotti 2026</p>
                  <p className="text-xs text-foreground-500 mt-0.5">Top 20 prodotti più popolari</p>
                </div>
                <i className="ri-arrow-right-line text-foreground-400 group-hover:text-accent-500 transition-colors"></i>
              </Link>
            </div>

            <div className="flex flex-wrap gap-4 text-xs text-foreground-500 font-label">
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-line text-accent-500"></i> Aggiornato: Luglio 2026
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-line text-accent-500"></i> Verificato dal team
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-line text-accent-500"></i> 220+ Risorse SEO
              </span>
            </div>
          </div>

          {/* Right: Stats + Images */}
          <div className="lg:w-3/5 flex flex-col gap-6">
            <div className="flex justify-end gap-8 md:gap-12">
              <div className="text-right">
                <p className="text-4xl md:text-5xl font-heading font-bold text-foreground-950">220+</p>
                <p className="text-xs text-foreground-500 font-label mt-1">Risorse SEO</p>
              </div>
              <div className="text-right">
                <p className="text-4xl md:text-5xl font-heading font-bold text-foreground-950">14</p>
                <p className="text-xs text-foreground-500 font-label mt-1">Categorie Prodotti</p>
              </div>
            </div>
            <div className="flex gap-4 justify-end">
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-2xl overflow-hidden flex-shrink-0 bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20editorial%20workspace%20with%20two%20researchers%20reviewing%20fashion%20product%20data%20on%20laptop%20screen%2C%20warm%20cream%20walls%2C%20large%20window%20with%20soft%20natural%20daylight%2C%20professional%20atmosphere%2C%20minimal%20decor%2C%20clean%20organized%20desk%2C%20editorial%20photography%2C%20sophisticated%20creative%20studio%2C%20warm%20neutral%20tones%2C%20no%20visible%20text%20on%20screen&width=480&height=480&seq=about-team-editorial-new-24&orientation=squarish"
                  alt="Team editoriale Itaobuy"
                  className="w-full h-full object-cover"
                  title="Itaobuy Research Team al lavoro"
                />
              </div>
              <div className="w-48 h-60 md:w-56 md:h-72 rounded-2xl overflow-hidden flex-shrink-0 mt-[-20px] bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Organized%20fashion%20product%20database%20displayed%20on%20modern%20monitor%20screen%20showing%20category%20grid%20with%20apparel%20items%2C%20warm%20cream%20background%2C%20soft%20ambient%20lighting%2C%20clean%20professional%20desk%20setup%2C%20editorial%20photography%20style%2C%20sophisticated%20minimal%20workspace%2C%20neutral%20beige%20tones%2C%20no%20text%20visible&width=560&height=720&seq=about-product-database-new-25&orientation=portrait"
                  alt="Database prodotti Itaobuy Spreadsheet"
                  className="w-full h-full object-cover"
                  title="Itaobuy Spreadsheet — database prodotti"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}